import { decorate, observable, flow } from 'mobx';
import Api from './APIEndpoints';
import { articlesInCompletedArticlesUrl } from './APIEndpoints';
import {appStore} from './AppStore';

const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

export default class CompletedArticlesStore {

  articles = [];
  listState = PENDING;
  rowCount = 0;

  constructor(props) {
    this.apiProxy = props.apiProxy;   
  }
  
  fetchCompletedArticles = flow(function* () {
    this.listState = PENDING;

    try {
      const params = { "where": { "userId":appStore.credentials.userId.toString()}, "limit": "5" }
      const data = yield Api.articlesInCompletedArticlesUrl.get(params);
      // const response = yield this.apiProxy.getAsync(articlesInCompletedArticlesUrl);
      // const data = yield response.json();

      this.articles = data;
      this.rowCount = data.length;
      this.listState = DONE;
    }
    catch (e) {
      this.listState = ERROR;
    };
  });

  
}

decorate(CompletedArticlesStore, {
  listState: observable,
  articles: observable,
  rowCount: observable
})
